import MainComponent from "../../components/Main/Main";

function Main() {
  return (
    <>
        <MainComponent />
    </>
  );
}

export default Main;
